<template>
    <section-layout class="section-patron">
        <div class="section-patron__content">
            <div class="container-fluid">
                <div class="d-flex justify-content-center section-patron__logos">
                    <h3>Patronat honorowy</h3>
                </div>
                <div class="d-flex flex-row align-items-center justify-content-center section-patron__logos">
                    <img height="106" class="section-patron__image" src="/05_znak_uproszczony_kolor_biale_tlo.png" alt="Patronat honorowy" />
                </div>
            </div>
        </div>

    </section-layout>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
    },
    components: {
    },
    computed: {
    },
};
</script>